import { Typography } from '@pvh-components/typography';
import { QRCodeSVG } from 'qrcode.react';
import React from 'react';
import styles from './stickyQR.module.css';

export interface StickyQRProps {
  url: string;
  tagline?: string;
  className?: string;
  children: React.ReactNode;
}

const StickyQR = ({
  url,
  tagline,
  children,
  className = '',
}: StickyQRProps) => {
  return (
    <div className={`${styles.stickyQrWrapper} ${className}`}>
      {children}
      <div className={`${styles.stickyQrStickyContainer}`}>
        <div className={`${styles.stickyQrCode}`}>
          <QRCodeSVG value={url} style={{ height: '100%', width: '100%' }} />
        </div>
        {tagline && (
          <Typography className={`${styles.stickyQrText}`} variant="h3">
            {tagline.toUpperCase()}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default StickyQR;
